<div>
  <h1 class="mb10">Your page is on its way</h1>
  <p class="mb30">To prevent any issues, avoid reloading this page.</p>
  <ul class="db-create-ai-process__steps mb30">
    <li *ngFor="let step of steps"
        [ngClass]="{'process': step?.status === 'process','passed': step?.status === 'passed'}">
      <i *ngIf="step?.status !== 'process'" class="db-icon"
         [ngClass]="{
          'circle': step?.status === 'todo',
          'db-icon-ds-checkmark': step?.status === 'passed'
         }"></i>
      <span *ngIf="step?.status === 'process'" class="ds-spinner-circle spinner"></span>
      <span [innerHTML]="step?.label"></span>
    </li>
  </ul>

</div>
<div *ngIf="!modalView && !isMobile" class="create-ai-video">
  <div class="overlay">
    <video #aiBuilderVideo (canplay)="playVideo()" [muted]="true" playsinline loop disablepictureinpicture
           controlsList="nodownload noplaybackrate noremoteplayback" width="100%" controls>
      <source src="../../../../../../../../assets/videos/ai_builder.mp4"
              type="video/mp4">
    </video>
  </div>
</div>
